import { useRequestGetUserPushes } from '@/hooks/httpRequest';
import PanelInfo from '../../PanelInfo';
import { BellOff } from 'lucide-react';
import DataTable from './dataTable/DataTable';

const ProfileDetailUserDataPushes = ({ userId }: { userId: string }) => {
	const { pushes, isLoadingPushes, error } = useRequestGetUserPushes({ userId });

	return (
		<div className="flex flex-col space-y-4 animate__animated animate__fadeIn">
			<div className="flex items-center mb-4">
				<h2 className="text-lg font-semibold tracking-tight">Pushes</h2>
				<span className="ml-2 text-xs text-muted-foreground">100 derniers</span>
			</div>
			{error ? (
				<p className="py-10 text-center text-sm text-destructive">Erreur lors du chargement.</p>
			) : !isLoadingPushes && pushes.length === 0 ? (
				<PanelInfo
					title="Aucun push."
					description="Aucun push envoyé à ce membre pour le moment."
					className="py-10 md:py-26 border-none"
					icon={BellOff}
				/>
			) : (
				<DataTable pushes={pushes} isLoading={isLoadingPushes} />
			)}
		</div>
	);
};

export default ProfileDetailUserDataPushes;
